import { Navigate } from "react-router-dom";

function CommunicationRedirect() {
    return <Navigate to="/communication/messages" />
}

export default CommunicationRedirect;
